import React from 'react';
import { useNavigate } from 'react-router-dom';
import selectedImage from '../Assets/pre-ordernow.png';

const Sticker = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/quick'); 
  };

  return (
    <div className="Sticker" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <img
        src={selectedImage}
        alt="Selected"
        style={{ width: "100%", height: "auto" }}
      /> 
    </div>
  );
};

export default Sticker;
